type CompareMode = 'previous_period' | 'previous_year';
type CustomRangeKind = 'date' | 'compare';
type LookbackDays = number | null | undefined;

function labelDays(lookbackDays: LookbackDays): string {
  if (lookbackDays === null || lookbackDays === undefined) {
    return 'the current plan window';
  }
  return `${lookbackDays} days`;
}

export function getLookbackPresetBlockedMessage(
  lookbackDays: LookbackDays,
): string {
  return `Your plan allows up to ${labelDays(lookbackDays)} of history. Upgrade to unlock longer date ranges.`;
}

export function getLookbackThisMonthBlockedMessage(
  lookbackDays: LookbackDays,
): string {
  return `This month starts before your plan lookback window (${labelDays(lookbackDays)}).`;
}

export function getLookbackThisYearBlockedMessage(
  lookbackDays: LookbackDays,
): string {
  return `This year starts before your plan lookback window (${labelDays(lookbackDays)}).`;
}

export function getLookbackCompareBlockedMessage(
  mode: CompareMode,
  lookbackDays: LookbackDays,
): string {
  if (mode === 'previous_period') {
    return `Previous period comparison needs more historical data than your current plan allows (${labelDays(lookbackDays)}).`;
  }
  return `Previous year comparison is outside your current lookback window (${labelDays(lookbackDays)}).`;
}

export function getLookbackCompareAutoDisabledMessage(
  mode: CompareMode,
  lookbackDays: LookbackDays,
): string {
  if (mode === 'previous_period') {
    return `Compare disabled: previous period is outside your ${labelDays(lookbackDays)} lookback.`;
  }
  return `Compare disabled: previous year is outside your ${labelDays(lookbackDays)} lookback.`;
}

export function getLookbackCustomRangeBlockedMessage(
  lookbackDays: LookbackDays,
  kind: CustomRangeKind,
): string {
  if (kind === 'compare') {
    return `Custom compare range exceeds your lookback limit (${labelDays(lookbackDays)}).`;
  }
  return `Custom date range exceeds your lookback limit (${labelDays(lookbackDays)}).`;
}

export function getLookbackPlanLimitCaption(
  lookbackDays: LookbackDays,
): string {
  return `Plan limit: you can analyze up to ${labelDays(lookbackDays)} of historical data.`;
}

export function getChatLookbackHint(lookbackDays: LookbackDays): string {
  return `Current plan limit: chat analyses can use up to ${labelDays(lookbackDays)} of historical data.`;
}
